/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerTrackPrev = createReactComponent("outline", "player-track-prev", "IconPlayerTrackPrev", [["path", { "d": "M21 5v14l-8 -7z", "key": "svg-0" }], ["path", { "d": "M10 5v14l-8 -7z", "key": "svg-1" }]]);

export { IconPlayerTrackPrev as default };
//# sourceMappingURL=IconPlayerTrackPrev.mjs.map
